import { IApplicationState } from '../../types/redux';

export const selectBuilderInfo = (state: IApplicationState) => {
  const { id, logo, name, fullName, phone, legalAddress, inn, kpp, ogrn, okpo, url, socials } = state.builderCard;

  return {
    id,
    logo,
    name,
    fullName,
    phone,
    legalAddress,
    inn,
    kpp,
    ogrn,
    okpo,
    url,
    socials,
  };
};
